import { render, staticRenderFns } from "./APIDocument.vue?vue&type=template&id=4fe82490&scoped=true&"
import script from "./APIDocument.vue?vue&type=script&lang=js&"
export * from "./APIDocument.vue?vue&type=script&lang=js&"
import style0 from "./APIDocument.vue?vue&type=style&index=0&id=4fe82490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe82490",
  null
  
)

export default component.exports